/**
 * Copyright © 2025 Delicious AI, LLC
 */

import dayjs from 'dayjs'

const isStoreInactive = (store: { inactiveAt: any }): boolean => {
  return !!store.inactiveAt && dayjs(store.inactiveAt).isBefore(dayjs())
}

export const StoreHelpers = {
  isStoreInactive,
}
